const closeMenu = (details, restoreFocus = false) => {
  if (!(details instanceof HTMLDetailsElement) || !details.open) return;
  details.open = false;
  if (restoreFocus) details.querySelector('summary')?.focus();
};
const openHeaderMenus = () => document.querySelectorAll('.ch-mobile-menu[open], .ch-nav-dropdown[open]');
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  const open = [...openHeaderMenus()];
  if (open.length) event.preventDefault();
  open.forEach((details) => closeMenu(details, true));
});
document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element)) return;
  const closeButton = event.target.closest('[data-ch-menu-close]');
  if (closeButton) closeMenu(closeButton.closest('.ch-mobile-menu'), true);
  openHeaderMenus().forEach((details) => {
    if (!details.contains(event.target) || event.target.closest('a')) closeMenu(details);
  });
});
document.addEventListener('toggle', (event) => {
  const details = event.target;
  if (!(details instanceof HTMLDetailsElement) || !details.open || !details.matches('.ch-mobile-menu, .ch-nav-dropdown')) return;
  openHeaderMenus().forEach((other) => { if (other !== details) closeMenu(other); });
}, true);
document.addEventListener('focusout', (event) => {
  if (!(event.target instanceof Element) || !(event.relatedTarget instanceof Element)) return;
  const dropdown = event.target.closest('.ch-nav-dropdown[open]');
  if (dropdown && !dropdown.contains(event.relatedTarget)) closeMenu(dropdown);
});
const updateHeaderMenuHeight = () => {
  document.querySelectorAll('.ch-header-wrap').forEach((header) => {
    header.style.setProperty('--ch-menu-offset', `${Math.max(0, header.getBoundingClientRect().bottom)}px`);
  });
};
const menuViewport = window.matchMedia('(max-width: 1199px)');
menuViewport.addEventListener('change', () => openHeaderMenus().forEach((details) => closeMenu(details)));
if ('ResizeObserver' in window) {
  const headerObserver = new ResizeObserver(updateHeaderMenuHeight);
  document.querySelectorAll('.ch-header-wrap').forEach((header) => headerObserver.observe(header));
}
window.addEventListener('resize', updateHeaderMenuHeight, { passive: true });
updateHeaderMenuHeight();
document.addEventListener('change', (event) => {
  const select = event.target;
  if (!(select instanceof HTMLSelectElement) || !select.matches('[data-ch-variant]')) return;
  const card = select.closest('[data-ch-product]');
  const option = select.selectedOptions[0];
  if (!card || !option) return;
  const price = card.querySelector('[data-ch-price]');
  const compare = card.querySelector('[data-ch-compare]');
  if (price) price.textContent = option.dataset.price || '';
  if (compare) {
    compare.textContent = option.dataset.compare || '';
    compare.hidden = option.dataset.onSale !== 'true';
  }
  const quantity = card.querySelector('[data-ch-quantity]');
  if (quantity instanceof HTMLInputElement) quantity.value = option.dataset.min || '1';
  const form = card.querySelector('product-form-component');
  if (form) form.dataset.quantityDefault = option.dataset.min || '1';
  card.querySelectorAll('[data-ch-product-link]').forEach((link) => {
    const url = new URL(link.href);
    url.searchParams.set('variant', select.value);
    link.href = url.href;
  });
}, true);

const initializeQuantityOffer = () => {
  if (!document.querySelector('main[data-template^="product"]')) return true;
  const bundle = document.querySelector('moonbundle-component[bundle]');
  if (!bundle) return false;
  let configuration;
  try { configuration = JSON.parse(bundle.getAttribute('bundle')); } catch { return false; }
  if (configuration.id !== '5718ca46-5af4-406d-be7b-3e7061c69f49') return true;
  const single = bundle.querySelector('[data-offer-id="ecc37d52-414c-40e8-893a-fe76beed6382"] > .moonbundle-option');
  if (!single) return false;
  if (!bundle.dataset.chSingleInitialized) {
    const container = bundle.closest('[class*="ai-product-info-section-"]');
    const gallery = bundle.closest('[data-ch-initial-variant]');
    bundle.dataset.chSingleInitialized = 'pending';
    if (!single.classList.contains('moonbundle-option-active')) single.click();
    // Moon Bundle releases its initialization lock after 300 ms.
    // Preserve the landing variant after that lock, without overriding an early user choice.
    let customerInteracted = false;
    const recordInteraction = (event) => { if (event.isTrusted) customerInteracted = true; };
    container?.addEventListener('pointerdown', recordInteraction, { once: true });
    container?.addEventListener('keydown', recordInteraction, { once: true });
    setTimeout(() => {
      if (gallery && !customerInteracted) {
        document.dispatchEvent(new CustomEvent('chaffection:variant-change', {
          detail: { productId: gallery.dataset.chProductId, variantId: gallery.dataset.chInitialVariant, source: 'quantity-offer-init' }
        }));
        gallery.querySelector('[data-variant-id]')?.dispatchEvent(new Event('change', { bubbles: true }));
      }
      container?.removeEventListener('pointerdown', recordInteraction);
      container?.removeEventListener('keydown', recordInteraction);
      bundle.dataset.chSingleInitialized = 'true';
    }, 450);
  }
  return true;
};
if (!initializeQuantityOffer()) {
  const offerObserver = new MutationObserver(() => {
    if (initializeQuantityOffer()) offerObserver.disconnect();
  });
  offerObserver.observe(document.body, { childList: true, subtree: true });
  setTimeout(() => offerObserver.disconnect(), 15000);
}
